module.exports = __webpack_public_path__ + "img/nenas.5fbe4ef6.jpeg";